import { request } from '@koi-design/vix-tools';
import { packApi } from '@/libs/tools';

export function addAiWrite(data) {
  return request({
    url: '/api/api-write/template/',
    method: 'post',
    data
  });
}

export function getAiWriteList(data) {
  return request({
    url: '/api/api-write/template/',
    method: 'get',
    data
  });
}
export function updateAiWrite(data) {
  return packApi({
    url: `/api/api-write/template/${data.template_uuid}/`,
    method: 'put',
    data
  });
}
export function deleteAiWrite(data) {
  return packApi({
    url: `/api/api-write/template/${data.template_uuid}/`,
    method: 'delete',
    data
  });
}

export function deleteAiWriteTemplate(data) {
  return packApi({
    url: `/api/api-write/template/delete_template/`,
    method: 'delete',
    data
  });
}

export function getAiWriteDetail(data) {
  return request({
    url: `/api/api-write/template/${data.id}/`,
    method: 'get'
  });
}

export function getAiWriteNextReleaseVersionApi(data) {
  return request({
    url: '/api/api-write/release/next_version/',
    method: 'get',
    data
  });
}

export function copyAiWrite(data) {
  return packApi({
    url: `/api/api-write/template/duplicate/`,
    method: 'post',
    data
  });
}

export function updateAiWriteConfig(data) {
  return packApi({
    url: `/api/api-write/template/upsert_template_config/`,
    method: 'post',
    data
  });
}

export function createVariable(data) {
  return request({
    url: `/api/api-write/variable/`,
    method: 'post',
    data
  });
}

export function getTemplateConfigApi(data) {
  return request({
    url: `/api/api-write/template/get_template_config/`,
    method: 'post',
    data
  });
}

export function updateTemplateConfigApi(data) {
  return request({
    url: `/api/api-write/template/upsert_template_config/`,
    method: 'post',
    data
  });
}

// /api/api-write/variable/
export function getVariableApi(data) {
  return request({
    url: `/api/api-write/variable/`,
    method: 'get',
    data
  });
}

export function getAiWriteContentRewriting(data) {
  return request({
    url: `/api/api-write/node/content_rewriting/`,
    method: 'post',
    data
  });
}

/**
 * @param {Object} data
 * @param {string} data.homeland_id
 * @param {string} data.template_uuid
 * @returns
 */
export function getAiWriteTask(data) {
  return request({
    url: `/api/api-write/task/`,
    method: 'get',
    data
  });
}

/**
 * @param {Object} data
 * @param {string} data.homeland_id
 * @param {string} data.template_uuid
 * @returns
 */
export function createAiWriteTask(data) {
  return request({
    url: `/api/api-write/task/`,
    method: 'post',
    data
  });
}

/**
 * @param {Object} data
 * @param {string} data.homeland_id
 * @param {string} data.task_uuid
 * @param {string} data.task_type
 * @returns
 */
export function getWriteTaskList(data) {
  return request({
    url: `/api/api-write/task/get_write_task_list/`,
    method: 'get',
    data
  });
}

// /api/api-write/file/website_upload/
export function uploadWebsiteFile(data) {
  return request({
    url: `/api/api-write/file/website_upload/`,
    method: 'post',
    data
  });
}

/**
 * @param {Object} data
 * @param {string} data.id
 * @param {string} data.tag
 * @returns
 */
export function updateFileTagApi(data) {
  return request({
    url: `/api/api-write/file/update_tag/`,
    method: 'post',
    data
  });
}
// /api/api-write/template/get_collect_info
export function getCollectInfoApi(data) {
  return request({
    url: `/api/api-write/template/get_collect_info/`,
    method: 'get',
    data
  });
}

export function getCollectInfoApiByTaskId(data) {
  return request({
    url: `/api/api-write/task/get_collect_info/`,
    method: 'get',
    data
  });
}

// /api/api-write/file/delete_file/
export function deleteFileApi(data) {
  return packApi({
    url: `/api/api-write/file/delete_file/`,
    method: 'delete',
    data
  });
}

export function retryFileParseApi(data) {
  return request({
    url: `/api/api-write/file/file_parse/`,
    method: 'get',
    data
  });
}

export function downloadFileApi(data) {
  return request({
    url: `/api/api-write/file/download_file/`,
    method: 'get',
    data,
    responseType: 'blob',
    catchAll: true
  });
}

export function createDataTask(data) {
  return request({
    url: `/api/api-write/template/create_data_task/`,
    method: 'post',
    data
  });
}

// New workflow-aware mutation adapters use the standard packApi contract.
export function createDataTaskApi(data) {
  return packApi(
    {
      url: `/api/api-write/template/create_data_task/`,
      method: 'post',
      data
    },
    'object'
  );
}

export function updateDataTask(data) {
  return request({
    url: `/api/api-write/template/update_data_task/`,
    method: 'post',
    data
  });
}

export function deleteDataTask(data) {
  return request({
    url: `/api/api-write/template/delete_data_task/`,
    method: 'delete',
    data
  });
}

export function updateDataTaskApi(data) {
  return packApi({
    url: `/api/api-write/template/update_data_task/`,
    method: 'post',
    data
  });
}

export function deleteDataTaskApi(data) {
  return packApi({
    url: `/api/api-write/template/delete_data_task/`,
    method: 'delete',
    data
  });
}

export function getDataTaskWorkflowApi(data) {
  return request({
    url: `/api/api-write/template/get_workflow_detail/`,
    method: 'get',
    data
  });
}

export function saveDataTaskWorkflowApi(flowUuid, data) {
  return packApi(
    {
      url: `/api/api-write/template/update_workflow/?flow_uuid=${encodeURIComponent(
        flowUuid
      )}`,
      method: 'put',
      data
    },
    'boolean',
    false
  );
}

/** Load the template-level data-task orchestration canvas. */
export function getDataTaskOrchestrationApi(data) {
  return request({
    url: `/api/api-write/template/get_data_task_orchestration/`,
    method: 'get',
    data
  });
}

/** Save the complete template-level data-task orchestration canvas. */
export function saveDataTaskOrchestrationApi(data) {
  const { template_uuid, homeland_id, ...payload } = data || {};
  const query = new URLSearchParams({
    template_uuid: template_uuid || '',
    ...(homeland_id !== undefined && homeland_id !== null
      ? { homeland_id: String(homeland_id) }
      : {})
  }).toString();
  return packApi(
    {
      url: `/api/api-write/template/update_data_task_orchestration/?${query}`,
      method: 'put',
      data: payload
    },
    'object',
    false
  );
}

/**
 * Load one data task's Workflow input and output variables.
 */
export function getDataTaskVariablesApi(data) {
  return request({
    url: `/api/api-write/template/get_data_task_variables/`,
    method: 'get',
    data
  });
}

/**
 * Load both sides of one orchestration dependency edge. The backend returns
 * source outputs and target inputs separately, with display values in
 * "<data task name>.<variable name>" form.
 */
export function getDataTaskEdgeVariablesApi(data) {
  return request({
    url: `/api/api-write/template/get_data_task_edge_variables/`,
    method: 'get',
    data
  });
}

/**
 * Load the upstream variables one Workflow node of a data task depends on.
 * The writing canvas has no robot, so ownership travels with the template.
 */
export function getDataTaskDependentVariableApi(data) {
  return request({
    url: `/api/api-write/template/get_data_task_dependent_variable/`,
    method: 'get',
    data
  });
}

/**
 * Load the node-to-line map of one data task Workflow canvas, used to animate
 * debug runs along the edges.
 */
export function getDataTaskWorkflowNodeApi(data) {
  return request({
    url: `/api/api-write/template/get_data_task_workflow_node/`,
    method: 'get',
    data
  });
}

/** Validate an orchestration canvas without writing it. */
export function validateDataTaskOrchestrationApi(data) {
  const { template_uuid, homeland_id, ...payload } = data || {};
  const query = new URLSearchParams({
    template_uuid: template_uuid || '',
    ...(homeland_id !== undefined && homeland_id !== null
      ? { homeland_id: String(homeland_id) }
      : {})
  }).toString();
  return request({
    url: `/api/api-write/template/validate_data_task_orchestration/?${query}`,
    method: 'post',
    data: payload
  });
}

/**
 * @param {Object} data
 * @param {string} data.template_uuid
 * @param {number} data.is_system 0 1
 * @returns
 */
export function getDataTask(data) {
  return request({
    url: `/api/api-write/template/get_data_task/`,
    method: 'get',
    data
  });
}

export function getDataTaskList(data) {
  return request({
    url: `/api/api-write/template/get_data_task_list/`,
    method: 'get',
    data
  });
}

export const getDataTaskApi = getDataTask;
export const getDataTaskListApi = getDataTaskList;

export function createTaskApi(data) {
  return request({
    url: `/api/api-write/task/`,
    method: 'post',
    data
  });
}

export function getTaskApi(data) {
  return request({
    url: `/api/api-write/task/${data.task_uuid}/`,
    method: 'get'
  });
}

export function updateTaskApi(data) {
  return request({
    url: `/api/api-write/task/${data.task_uuid}/`,
    method: 'put',
    data
  });
}

export function deleteTaskApi(data) {
  return request({
    url: `/api/api-write/task/${data.task_uuid}/`,
    method: 'delete'
  });
}

export function getWritingInstructionsApi(data) {
  return request({
    url: `/api/api-write/task/get_writing_instructions/`,
    method: 'get',
    data
  });
}

/**
 * @param {Object} data
 * @param {string} data.homeland_id
 * @param {string} data.relation_uuid
 * @param {number} data.relation_type
 * @returns
 */
export function getFileList(data) {
  return request({
    url: `/api/api-write/file/`,
    method: 'get',
    data
  });
}

/**
 * @param {Object} data
 * @param {Object} data.body
 * @param {Array} data.body.data
 * @param {string} data.body.raw_text
 * @param {string} data.body.type
 * @param {Array} data.headers
 * @param {string} data.headers[].name
 * @param {string} data.headers[].value
 * @param {string} data.method
 * @param {Array} data.params
 * @param {string} data.params[].name
 * @param {string} data.params[].value
 * @param {string} data.title
 * @param {string|null} data.proxy
 * @param {string} data.url
 * @returns
 */
export function apiCall(data) {
  return request({
    url: `/api/api-write/file/apicall/`,
    method: 'post',
    data
  });
}

/**
 * Upload API call result as file
 * @param {Object} data
 * @param {number} data.homeland_id
 * @param {string} data.relation_uuid - template_uuid or task_uuid based on relation_type
 * @param {number} data.relation_type - 1 for template, 2 for task
 * @param {Object} data.apicall_data
 * @param {string} data.apicall_data.content - API call result data
 * @param {string} data.apicall_data.url - API endpoint URL
 * @param {string} data.apicall_data.title - File name (required)
 * @param {Object} data.apicall_data.extra_params - All request parameters for tracking
 * @returns
 */
export function apiCallUpload(data) {
  return request({
    url: `/api/api-write/file/apicall_upload/`,
    method: 'post',
    data
  });
}

/**
 * @param {Object} data
 * @param {number} data.id
 * @returns
 */
export function selectDataTask(data) {
  return request({
    url: `/api/api-write/template/select_data_task/`,
    method: 'post',
    data
  });
}

/**
 * @param {Object} data
 * @param {string} data.template_uuid
 * @param {string} data.homeland_id
 * @returns
 */
export function getSearchScope(data) {
  return request({
    url: `/api/api-write/template/get_search_scope/`,
    method: 'get',
    data
  });
}

export function stopTaskApi(data) {
  return packApi({
    url: `/api/api-write/task/stop_task/`,
    method: 'get',
    data
  });
}

export function restartTaskApi(data, showTip = true) {
  return packApi(
    {
      url: `/api/api-write/task/start_task/`,
      method: 'get',
      data
    },
    'boolean',
    showTip
  );
}

/**
 * @param {Object} data
 * @param {string} data.homeland_id
 * @param {string} data.task_uuid
 * @param {string} data.tag
 * @returns
 */
export function getTagFiles(data) {
  return request({
    url: `/api/api-write/file/get_tag_files/`,
    method: 'get',
    data
  });
}

/**
 * @param {Object} data
 * @param {string} data.homeland_id
 * @param {string} data.template_uuid
 * @returns
 */
export function publishTemplateApi(data) {
  return request({
    url: `/api/api-write/template/publish/`,
    method: 'post',
    data
  });
}

/**
 * @param {Object} data
 * @param {string} data.task_uuid
 * @param {string} data.homeland_id
 * @returns
 */
export function getReleaseListApi(data) {
  return request({
    url: `/api/api-write/task/get_release_list/`,
    method: 'get',
    data
  });
}

/**
 * @param {Object} data
 * @param {string} data.release_uuid
 * @param {string} data.task_uuid
 * @param {string} data.homeland_id
 * @returns
 */
export function getReleaseDetailApi(data) {
  return request({
    url: `/api/api-write/task/get_release_detail/`,
    method: 'get',
    data
  });
}

/**
 * @param {Object} data
 * @param {string} data.task_uuid
 * @param {Object} data.node_info
 * @returns
 */
export function nodeExecutor(data) {
  return request({
    url: `/api/api-write/node/node_executor/`,
    method: 'post',
    data
  });
}

/**
 * @param {Object} data
 * @param {string} data.task_uuid
 * @param {string} data.node_uuid
 * @returns
 */
export function getNodeApi(data) {
  return request({
    url: `/api/api-write/node/`,
    method: 'get',
    data
  });
}

/**
 * @param {Object} data
 * @param {string} data.task_uuid
 * @param {string} data.homeland_id
 * @returns
 */
export function saveTaskApi(data) {
  return request({
    url: `/api/api-write/task/save/`,
    method: 'post',
    data
  });
}

/**
 * @param {Object} data
 * @param {string} data.release_uuid
 * @param {string} data.task_uuid
 * @param {string} data.homeland_id
 * @param {string} data.filetype
 * @returns
 */
export function downloadArticleFileApi(data) {
  return request({
    url: `/api/api-write/task/download_file/`,
    method: 'get',
    data,
    responseType: 'blob',
    catchAll: true
  });
}

/**
 * @param {Object} data
 * @param {string} data.file
 * @returns
 */
export function uploadImageApi(data) {
  return request({
    url: `/api/api-write/file/upload_image/`,
    method: 'post',
    data
  });
}

/**
 * @param {Object} data
 * @param {string} data.node_uuid
 * @param {string} data.task_uuid
 * @returns
 */
export function getRagResApi(data) {
  return request({
    url: `/api/api-write/task/get_rag_res/`,
    method: 'get',
    data
  });
}

/**
 * @param {Object} data
 * @param {string} data.source_type
 * @param {string} data.file_id
 * @returns
 */
export function previewFileApi(data) {
  return request({
    url: `/api/api-write/file/preview_file/`,
    method: 'get',
    data,
    responseType: 'blob',
    catchAll: true
  });
}

/**
 * @param {Object} data
 * @param {string} data.homeland_id
 * @returns
 */
export function getLlmModelOptionsApi(data) {
  return request({
    url: `/api/api-write/template/get_llm_model_options/`,
    method: 'get',
    data
  });
}

export function getContentChapterPromptApi(data) {
  return request({
    url: `/api/api-write/template/get_content_chapter_prompt/`,
    method: 'get',
    data
  });
}

/**
 * export template
 * @param {Object} data
 * @param {string} data.template_uuid
 * @param {string} data.homeland_id
 * @returns
 */
export function exportTemplateApi(data) {
  return request({
    url: `/api/api-write/template/export_template/`,
    method: 'get',
    data,
    responseType: 'blob',
    catchAll: true
  });
}

/**
 * import template
 * @param {Object} data
 * @param {string} data.file
 * @param {string} data.homeland_id
 * @returns
 */
export function importTemplateApi(data) {
  return request({
    url: `/api/api-write/template/import_template/`,
    method: 'post',
    data
  });
}

/**
 * release template
 * @param {Object} data
 * @param {string} data.homeland_id
 * @param {string} data.template_uuid
 * @param {number} data.release_type
 * @returns
 */
export function releaseTemplateApi(data) {
  return request({
    url: `/api/api-write/release/`,
    method: 'post',
    data
  });
}

/**
 * offline template
 * @param {Object} data
 * @param {string} data.template_uuid
 * @returns
 */
export function offlineTemplateApi(data) {
  return packApi({
    url: `/api/api-write/store/offline/`,
    method: 'put',
    data
  });
}

/**
 * get template tags
 * @returns
 */
export function getTemplateTagsApi() {
  return request({
    url: `/api/api-write/store/tags/`,
    method: 'get'
  });
}

/**
 * copy template in store
 * @param {Object} data
 * @param {string} data.template_uuid
 * @param {string} data.homeland_id
 * @returns
 */
export function copyTemplateApi(data) {
  return request({
    url: `/api/api-write/store/copy/`,
    method: 'post',
    data,
    catchAll: true
  });
}

/**
 * copy template in store
 * @param {Object} data
 * @param {string} data.template_uuid
 * @param {string} data.homeland_id
 * @returns
 */
export function shopTemplateApi(data) {
  return request({
    url: `/api/api-agent/enterprise/copy_write/`,
    method: 'post',
    data,
    catchAll: true
  });
}

/**
 * @param {Object} data
 * @param {string} data.template_uuid
 * @param {string} data.homeland_id
 * @returns
 */
export function getReleaseRecordApi(data) {
  return request({
    url: `/api/api-write/release/record/`,
    method: 'get',
    data
  });
}

/**
 * @param {Object} data
 * @param {string} data.template_uuid
 * @returns
 */
export function getReleaseDescApi(data) {
  return request({
    url: `/api/api-write/release/desc/`,
    method: 'get',
    data
  });
}

/**
 * download file section
 * @param {Object} data
 * @param {string} data.homeland_id
 * @param {string} data.id
 * @returns
 */
export function downloadFileSectionApi(data) {
  return request({
    url: `/api/api-write/file/download_file_section/`,
    method: 'get',
    data,
    responseType: 'blob',
    catchAll: true
  });
}

/**
 * @param {Object} data
 * @param {string} data.template_uuid
 * @param {string} data.homeland_id
 * @param {string} data.search
 * @param {string} data.status
 * @param {string} data.start_time
 * @param {string} data.end_time
 * @returns
 */
export function getAnalysisApi(data) {
  return request({
    url: `/api/api-write/template/analysis/`,
    method: 'get',
    data
  });
}

/**
 * @param {Object} data
 * @param {string} data.template_uuid
 * @returns
 */
export function getTemplateCollectApi(data) {
  return packApi({
    url: `/api/api-write/store/collect/`,
    method: 'put',
    data
  });
}

/**
 * @param {Object} data
 * @param {string} data.template_uuid
 * @returns
 */
export function getStoreStatusApi(data) {
  return request({
    url: `/api/api-write/store/get_store_status/`,
    method: 'get',
    data
  });
}

/**
 * @param {Object} data
 * @param {string} data.template_uuid
 * @returns
 */
export function getTemplateDefaultApi() {
  return request({
    url: `/api/api-write/template/get_default_write_template/`,
    method: 'get'
  });
}

/**
 * @param {Object} data
 * @param {string} data.homeland_id
 * @param {string} data.template_uuid
 * @returns
 */
export function getTemplateUserPermissionRoleApi(data) {
  return request({
    url: `/api/api-write/template/get_template_user_permission_role/`,
    method: 'get',
    data
  });
}

/**
 * @param {Object} data
 * @param {string} data.template_uuid
 * @param {string} data.node_uuid
 * @param {string} data.node_info
 * @param {string} data.inputs
 * @returns
 */
export function nodeTestApi(data) {
  return request({
    url: `/api/api-write/node/node_test/`,
    method: 'post',
    data
  });
}

/**
 * @param {Object} data
 * @param {string} data.template_uuid
 * @param {string} data.node_uuid
 * @returns
 */
export function getNodeTestListApi(data) {
  return request({
    url: `/api/api-write/node/get_node_test_list/`,
    method: 'get',
    data
  });
}

/**
 * @param {Object} data
 * @param {string} data.flow_uuid
 * @param {string} data.homeland_id
 * @param {string} data.template_uuid
 * @param {string} data.data_task_id
 * @returns
 */
export function exportWriteFlowApi(data) {
  return request({
    url: `/api/api-write/template/export_write_flow/`,
    method: 'get',
    data,
    responseType: 'blob',
    catchAll: true
  });
}

/**
 * @param {Object} data
 * @param {string} data.file
 * @param {string} data.homeland_id
 * @param {string} data.flow_uuid
 * @returns
 */
export function importWriteFlowApi(data) {
  return request({
    url: `/api/api-write/template/import_data_task/`,
    method: 'post',
    data
  });
}

export function getReleaseHtmlDetailApi(data) {
  return request({
    url: `/api/api-write/write/html_detail/`,
    method: 'get',
    data
  });
}

export function taskInvisibleTaskApi(data) {
  return packApi({
    url: `/api/api-write/task/invisible/?task_uuid=${data.task_uuid}&homeland_id=${data.homeland_id}`,
    method: 'delete'
  });
}

export function getPreviewFileInfoApi(data) {
  return request({
    url: `/api/api-write/file/preview_file_info/`,
    method: 'get',
    data
  });
}

export function getTemplatePlatformConfigApi(data) {
  return request({
    url: `/api/api-write/template/get_platform_config/`,
    method: 'get',
    data
  });
}

export function editParseFileContentApi(data) {
  return packApi({
    url: `/api/api-write/file/edit_parse_file_content/`,
    method: 'post',
    data
  });
}

export function getAiWriteReleaseRecordApi(data) {
  return request({
    url: `/api/api-write/release/record/`,
    method: 'get',
    data
  });
}

export function restoreFromReleaseApi(data) {
  return request({
    url: `/api/api-write/template/restore_from_release/`,
    method: 'post',
    data
  });
}

export function continueTaskApi(data) {
  return request({
    url: `/api/api-write/task/continue_task/`,
    method: 'get',
    data
  });
}

export function confirmFileEditApi(data) {
  return packApi({
    url: `/api/api-write/file/confirma_file_edit/`,
    method: 'post',
    data
  });
}

export function getConfirmFileApi(data) {
  return request({
    url: `/api/api-write/file/get_confirma_file/`,
    method: 'get',
    data
  });
}

export function uploadHotwordsApi(data) {
  return request({
    url: `/api/api-write/template/upload_hotwords/`,
    method: 'post',
    data
  });
}

export function getHotwordsTemplateApi(data) {
  return request({
    url: `/api/api-write/template/hotwords_tmpl/`,
    method: 'get',
    data,
    responseType: 'blob',
    catchAll: true
  });
}

export function downloadHotwordsApi(data) {
  return request({
    url: `/api/api-write/template/download_hotwords/`,
    method: 'get',
    data,
    responseType: 'blob',
    catchAll: true
  });
}

export function getAudioFileParseModelOptionsApi(data) {
  return request({
    url: `/api/api-write/template/get_audio_file_parse_model_options/`,
    method: 'get',
    data
  });
}

export function getParseModelOptionsApi(data) {
  return request({
    url: `/api/api-write/template/get_parse_model_option/`,
    method: 'get',
    data
  });
}

export function getSimpleOutlineApi(data) {
  return request({
    url: `/api/api-write/task/get_simple_outline/`,
    method: 'get',
    data
  });
}

export function restoreTaskVersionApi(data) {
  return request({
    url: `/api/api-write/task/restore_task_version/`,
    method: 'get',
    data
  });
}

export function getDataProvenanceApi(data) {
  return request({
    url: `/api/api-write/task/data_provenance/`,
    method: 'post',
    data
  });
}

export function getDataTaskProvenanceApi(data) {
  return request({
    url: `/api/api-write/task/data_task_provenance/`,
    method: 'post',
    data
  });
}

export function updateOutlineContentApi(data) {
  return request({
    url: `/api/api-write/task/update_outline_content/`,
    method: 'post',
    data
  });
}

export function saveContentApi(data) {
  return request({
    url: `/api/api-write/task/save_content/`,
    method: 'post',
    data
  });
}

export function getProvenanceFileApi(data) {
  return request({
    url: `/api/api-write/file/get_provenance_file/`,
    method: 'get',
    data,
    responseType: 'blob',
    catchAll: true
  });
}

export function deleteTaskReleaseApi(data) {
  return packApi({
    url: `/api/api-write/task/delete_task_release/`,
    method: 'post',
    data
  });
}

export function startUploadApi(data) {
  return request({
    url: `/api/api-write/file/start_upload/`,
    method: 'post',
    data
  });
}
